import { Col, Container, Row } from "reactstrap";

const Footer = () => {
  return (
    <>
      <footer className="footer">
        <Container fluid>
          <Row>
            <Col sm={6}></Col>
          </Row>
        </Container>
      </footer>
    </>
  );
};

export default Footer;
